import React from 'react';
import '../../styles/app/TermsAndConditions.css';
import WhatsAppBanner from './WhatsAppBanner';
import Nav from './Nav';
import { useTranslation } from 'react-i18next';

const TermsAndConditions: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <WhatsAppBanner />
      <Nav />
      <section className="terms-section">
        <div className="terms-container">
          <h1>{t('termsAndConditions.title')}</h1>

          <h2>{t('termsAndConditions.introduction.title')}</h2>
          <p>{t('termsAndConditions.introduction.paragraph')}</p>

          <h2>{t('termsAndConditions.useOfService.title')}</h2>
          <p>{t('termsAndConditions.useOfService.paragraph')}</p>

          <h2>{t('termsAndConditions.plansAndPayments.title')}</h2>
          <p>{t('termsAndConditions.plansAndPayments.paragraph')}</p>

          <h2>{t('termsAndConditions.refundPolicy.title')}</h2>
          <p>{t('termsAndConditions.refundPolicy.paragraph')}</p>

          <h2>{t('termsAndConditions.intellectualProperty.title')}</h2>
          <p>{t('termsAndConditions.intellectualProperty.paragraph')}</p>

          <h2>{t('termsAndConditions.changesToTerms.title')}</h2>
          <p>{t('termsAndConditions.changesToTerms.paragraph')}</p>

          <h2>{t('termsAndConditions.contact.title')}</h2>
          <p>{t('termsAndConditions.contact.paragraph')}</p>
        </div>
      </section>
    </>
  );
};

export default TermsAndConditions;
